import React from 'react';
import I18n from 'i18n-js';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

import { findProductFamilySpec, shouldDisplayProductFamilyLink } from '@reverbdotcom/commons/src/product_family_helpers';
import dotMatrixPattern from '../../images/dot_matrix_pattern.jpg';
import { core_apimessages_ProductSpec } from '../schemas/rql';

interface IProps {
  productSpecs: core_apimessages_ProductSpec[];
  thumbnailImage: string;
}

export function ProductFamilyCTA(props: IProps) {
  const mparticleEvent: MParticleEvent = {
    componentName: 'ProductFamilyCTA',
    eventName: MParticleEventName.ComponentView,
  };

  const productFamily = findProductFamilySpec(props.productSpecs);

  // track a component view if a product family exists
  const shouldTrack = !!productFamily;
  useViewTracking(mparticleEvent, shouldTrack);

  const shouldDisplay = shouldDisplayProductFamilyLink(props.productSpecs);

  if (!shouldDisplay) {
    return null;
  }

  const clickEvent = {
    eventName: MParticleEventName.ClickedComponent,
    componentName: 'ProductFamilyCTA',
    entityType: 'url',
    entityId: productFamily.path,
  };

  return (
    <CoreLink
      to={productFamily.path}
      clickEvent={clickEvent}
      target="_top"
      className="product-family-cta"
      style={{ backgroundImage: `url(${dotMatrixPattern})` }}
    >
      <div className="product-family-cta__image">
        <img
          src={props.thumbnailImage}
          alt={productFamily.value}
        />
      </div>
      <div className="product-family-cta__content">
        <div>
          <h4 className="size-140">{productFamily.value}</h4>
          <p className="mb-0">
            {I18n.t('discovery.productFamilyCTA.deals')}
          </p>
        </div>
        <span className="product-family-cta__action">
          {I18n.t('discovery.productFamilyCTA.seeMore')}
        </span>
      </div>
    </CoreLink>
  );
}
